import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import routes from './routes'
import { isSubAppFlowPath, loadSubAppFlow, isExitSubAppFlow, exitSubAppFlow } from '@/utils/forSubAppFlow'

Vue.use(VueRouter)

//  Fix Uncaught (in promise) NavigationDuplicated {_name: "NavigationDuplicated"}
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.authRequired && !store.state.user.token && process.env.VUE_APP_BUILD_ENV !== 'Fabric') {
    next({ path: '/login' })
  } else if (isSubAppFlowPath(to.path)) {
    if (to.path === from.path) {
      return
    }
    next()
    loadSubAppFlow()
  } else if (isExitSubAppFlow(from.path, to.path)) {
    exitSubAppFlow()
    next()
  } else {
    next()
  }
})

export default router
